import React, { useState } from "react";
import { useResponsiveHeight } from "../hooks/useResponsiveHeight";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGauge,
  faUser,
  faEllipsisH,
  faCalendarDays,
  faGear,
  faFootball,
  faUserTie,
  faHelmetUn,
  faUserPlus,
  faClone,
} from "@fortawesome/free-solid-svg-icons";

const BottomNav = () => {
  const [showMore, setShowMore] = useState(false);
  const [active, setActive] = useState("Dashboard");

  const { isMobile } = useResponsiveHeight();

  return (
    <div className="fixed bottom-0 left-0 w-full bg-[#545353] z-50 xl:hidden">
      {/* More Items (shown above nav) - only on mobile */}
      {isMobile && showMore && (
        <div className="flex justify-around items-center pb-2 pt-0 border-b border-gray-50 bg-[#545353] transition-all">
          <Link to="/admin/calendar">
            <NavItem
              icon={faCalendarDays}
              label="Calendar"
              active={active}
              setActive={setActive}
            />
          </Link>
          <Link to="/admin/settings">
            <NavItem
              icon={faGear}
              label="Settings"
              active={active}
              setActive={setActive}
            />
          </Link>
          <Link to="/admin/account">
            <NavItem
              icon={faUser}
              label="Account"
              active={active}
              setActive={setActive}
            />
          </Link>
          <Link to="/admin/candidate-athletes">
            <NavItem
              icon={faUserPlus}
              label="Potential"
              active={active}
              setActive={setActive}
            />
          </Link>
          <Link to="/admin/duplicate-users">
            <NavItem
              icon={faClone}
              label="Duplicates"
              active={active}
              setActive={setActive}
            />
          </Link>
        </div>
      )}

      <div className="flex justify-around items-center pb-3 pt-0">
        {/* Main Menu Items */}
        <Link to="/admin/dashboard">
          <NavItem
            icon={faGauge}
            label="Dashboard"
            active={active}
            setActive={setActive}
          />
        </Link>
        <Link to="/admin/athletes">
          <NavItem
            icon={faHelmetUn}
            label="Athletes"
            active={active}
            setActive={setActive}
          />
        </Link>
        <Link to="/admin/coaches">
          <NavItem
            icon={faUserTie}
            label="Coaches"
            active={active}
            setActive={setActive}
          />
        </Link>
        <Link to="/admin/combine">
          <NavItem
            icon={faFootball}
            label="Combines"
            active={active}
            setActive={setActive}
          />
        </Link>
        {/* More Button - only on mobile */}
        {isMobile ? (
          <button
            onClick={() => setShowMore(!showMore)}
            className="flex flex-col pt-2 items-center text-gray-100 hover:text-red-500"
          >
            <FontAwesomeIcon icon={faEllipsisH} size="lg" />
            <span className="text-xs pt-2">More</span>
          </button>
        ) : (
          <>
            <Link to="/admin/calendar">
              <NavItem
                icon={faCalendarDays}
                label="Calendar"
                active={active}
                setActive={setActive}
              />
            </Link>
            <Link to="/admin/settings">
              <NavItem
                icon={faGear}
                label="Settings"
                active={active}
                setActive={setActive}
              />
            </Link>
            <Link to="/admin/account">
              <NavItem
                icon={faUser}
                label="Account"
                active={active}
                setActive={setActive}
              />
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

const NavItem = ({ icon, label, active, setActive }) => {
  const isActive = active === label;
  return (
    <div
      className={`relative flex flex-col items-center cursor-pointer pt-4 ${
        isActive ? "text-red-500" : "text-gray-100 hover:text-red-500"
      }`}
      onClick={() => setActive(label)}
    >
      {isActive && (
        <span
          className="absolute top-0 w-full h-1 bg-red-500"
          style={{ height: "5px" }}
        ></span>
      )}
      <FontAwesomeIcon icon={icon} size="lg" />
      <span className="text-xs mt-1">{label}</span>
    </div>
  );
};

export default BottomNav;
